<template lang="pug">
  modal.shipping-modal(v-on="$listeners")
    template(slot="header")
      h3.reader-show(tabindex="0") Shipping and Returns
      h6 {{ product.vendor }}<br>{{ product.title }}
    section
      wp-rich-text.children-mt-em(:html="summary", v-if="summary")
    footer.py-90.flex.justify-center
      wp-link(:link="fullPolicyLink", v-if="fullPolicyLink")
        link-with-arrow Full {{ fullPolicyLink.title }}
      //- template(v-for="slice in doc.acf.body")
        template(v-if="slice.acf_fc_layout === 'header'")
          h4.mb-em {{ slice.header }}
        template(v-else-if="slice.acf_fc_layout === 'text'")
          wp-rich-text.bulleted-lists.children-mt-em.mb-60(:html="slice.text")
</template>

<script>
import { mapState } from 'vuex'
import LinkWithArrow from '@/components/LinkWithArrow'
export default {
  name: 'ShippingModal',
  props: ['product'],
  // data () {
  //   return {
  //     doc: null
  //   }
  // },
  computed: {
    ...mapState({
      summary: state => state.site && state.site.hostem_shipping_returns_summary,
      policies: state => state.site && state.site.hostem_footer_links
    }),
    fullPolicyLink () {
      const item = this.policies.find(policy => policy.link && policy.link.title.toLowerCase().includes('shipping'))
      return item && item.link
    }
  },
  components: { LinkWithArrow }
  // methods: {
  //   async get () {
  //     this.doc = await this.$store.dispatch('getPage', 'shipping-and-returns')
  //   }
  // },
  // created () {
  //   this.get()
  // }
}
</script>

<style>
</style>
